export const DUBAI_ARABIC_RANGE = 'U+0030-0039,U+0600-06FF,U+200C-200E,U+2010-2011,U+204F,U+2E41,U+FB50-FDFF,U+FE80-FEFC';
export const DUBAI_LATIN_RANGE = 'U+0020-007F';
export const DUBAI_LATIN_EXT_RANGE = 'U+0080-02AF,U+02C6-02C9,U+02DA-02DD,U+0300-036F,U+1E00-1EFF,U+2011-2265,U+2C60-2C7F,U+FB01-FB02';
